import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateProvider {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/NewSubscription.js